export const CLOSED = 'Closed';
export const OPEN_24_HOURS = 'Open 24 hours';
export const DEFAULT_MAP_ZOOM = 6;
export const SELECTED_STORE_ID = 'selectedStoreId';
export const TERMS_CHECKED = 'termsChecked';
export const SORT_ORDER = 'sortOrder';
export const OPTIONS = 'options';
